import { render } from "./ProductInformationText.vue?vue&type=template&id=23d244eb"
import script from "./ProductInformationText.vue?vue&type=script&lang=js"
export * from "./ProductInformationText.vue?vue&type=script&lang=js"

import "./ProductInformationText.vue?vue&type=style&index=0&id=23d244eb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__